//GENERIC ACTIONS
export const CHANGE_EVENT            = 'CHANGE_EVENT';
export const REQ_DATA                = 'REQ_DATA';
export const RECV_DATA               = 'RECV_DATA';
export const RECV_ERROR              = 'RECV_ERROR';
export const RECV_MSG                = 'RECV_MSG';
export const CLEAR_ERROR             = 'CLEAR_ERROR';

// BROWSER
export const BROWSER_RESIZE          = 'BROWSER_RESIZE';
export const UPDATE_SCROLLER          = 'UPDATE_SCROLLER';

//MENU ACTIONS
export const MENU_TOGGLE             = 'MENU_TOGGLE';
export const MENU_CLOSE              = 'MENU_CLOSE';
export const MENU_TOGGLE_SEARCH      = 'MENU_TOGGLE_SEARCH';
export const MENU_FETCH              = 'MENU_FETCH';
export const MENU_UPDATE_SUB         = 'MENU_UPDATE_SUB';
export const MENU_REQ_DATA           = 'MENU_REQ_DATA';
export const MENU_RECV_DATA          = 'MENU_RECV_DATA';
export const MENU_RECV_ERROR         = 'MENU_RECV_ERROR';

//JOBS ACTIONS
export const JOBS_FETCH              = 'JOBS_FETCH';
export const JOBS_UPDATE_SUB         = 'JOBS_UPDATE_SUB';
export const JOBS_REQ_DATA           = 'JOBS_REQ_DATA';
export const JOBS_RECV_DATA          = 'JOBS_RECV_DATA';
export const JOBS_RECV_ERROR         = 'JOBS_RECV_ERROR';
export const JOBS_REQ_DATA_SINGLE    = 'JOBS_REQ_DATA_SINGLE';
export const JOBS_RECV_DATA_SINGLE   = 'JOBS_RECV_DATA_SINGLE';
export const JOBS_RECV_ERROR_SINGLE  = 'JOBS_RECV_ERROR_SINGLE';

//JOBS ACTIONS
export const NEWS_FETCH              = 'NEWS_FETCH';
export const NEWS_UPDATE_SUB         = 'NEWS_UPDATE_SUB';
export const NEWS_REQ_DATA           = 'NEWS_REQ_DATA';
export const NEWS_RECV_DATA          = 'NEWS_RECV_DATA';
export const NEWS_RECV_ERROR         = 'NEWS_RECV_ERROR';
export const NEWS_REQ_DATA_SINGLE    = 'NEWS_REQ_DATA_SINGLE';
export const NEWS_RECV_DATA_SINGLE   = 'NEWS_RECV_DATA_SINGLE';
export const NEWS_RECV_ERROR_SINGLE  = 'NEWS_RECV_ERROR_SINGLE';

//CASES ACTIONS
export const CASES_CLEAR_DATA         = 'CASES_CLEAR_DATA';
export const CASES_FETCH              = 'CASES_FETCH';
export const CASES_FETCH_WINNERS      = 'CASES_FETCH_WINNERS';
export const CASES_REQ_DATA           = 'CASES_REQ_DATA';
export const CASES_REQ_SINGLE_DATA    = 'CASES_REQ_SINGLE_DATA';
export const CASES_RECV_DATA          = 'CASES_RECV_DATA';
export const CASES_RECV_DATA_CONT     = 'CASES_RECV_DATA_CONT';
export const CASES_RECV_SINGLE_DATA   = 'CASES_RECV_SINGLE_DATA';
export const CASES_RECV_ERROR         = 'CASES_RECV_ERROR';

//EDITORIALS ACTIONS
export const EDITORIALS_FETCH              = 'EDITORIALS_FETCH';
export const EDITORIALS_FETCH_SINGLE       = 'EDITORIALS_FETCH_SINGLE';
export const EDITORIALS_CLEAR_SINGLE       = 'EDITORIALS_CLEAR_SINGLE';
export const EDITORIALS_REQ_DATA           = 'EDITORIALS_REQ_DATA';
export const EDITORIALS_REQ_SINGLE_DATA    = 'EDITORIALS_REQ_DATA';
export const EDITORIALS_RECV_DATA          = 'EDITORIALS_RECV_DATA';
export const EDITORIALS_RECV_TYPE_DATA     = 'EDITORIALS_RECV_TYPE_DATA';
export const EDITORIALS_RECV_SINGLE_DATA   = 'EDITORIALS_RECV_SINGLE_DATA';
export const EDITORIALS_RECV_ERROR         = 'EDITORIALS_RECV_ERROR';

//PAGES ACTIONS
export const PAGES_REQ_SINGLE_DATA          = 'PAGES_REQ_SINGLE_DATA';
export const PAGES_RECV_SINGLE_DATA         = 'PAGES_RECV_SINGLE_DATA';
export const PAGES_RECV_ERROR               = 'PAGES_RECV_ERROR';

//AGENCIES ACTIONS
export const PROFILES_FETCH              = 'PROFILES_FETCH';
export const PROFILES_FETCH_SINGLE       = 'PROFILES_FETCH_SINGLE';
export const PROFILES_CLEAR_DATA         = 'PROFILES_CLEAR_DATA';
export const PROFILES_REQ_DATA           = 'PROFILES_REQ_DATA';
export const PROFILES_REQ_SINGLE_DATA    = 'PROFILES_REQ_SINGLE_DATA';
export const PROFILES_RECV_DATA          = 'PROFILES_RECV_DATA';
export const PROFILES_RECV_SINGLE_DATA   = 'PROFILES_RECV_SINGLE_DATA';
export const PROFILES_RECV_CASE_DATA   	 = 'PROFILES_RECV_CASE_DATA';
export const PROFILES_RECV_ERROR         = 'PROFILES_RECV_ERROR';

//JURY ACTIONS
export const JURY_RECV_DATA 			 = 'JURY_RECV_DATA';
export const JURY_RECV_ERROR 			 = 'JURY_RECV_ERROR';

//TIMELINE ACTIONS
export const TIMELINE_CLEAR_DATA         = 'TIMELINE_CLEAR_DATA';
export const TIMELINE_REQ_DATA           = 'TIMELINE_REQ_DATA';
export const TIMELINE_RECV_ERROR         = 'TIMELINE_RECV_ERROR';
export const TIMELINE_FILTER             = 'TIMELINE_FILTER';

export const TIMELINE_RECV_INIT_DATA     = 'TIMELINE_RECV_INIT_DATA';
export const TIMELINE_RECV_NEXT_DATA     = 'TIMELINE_RECV_NEXT_DATA';
export const TIMELINE_RECV_PREV_DATA     = 'TIMELINE_RECV_PREV_DATA';
export const TIMELINE_FETCH_NEXT         = 'TIMELINE_FETCH_NEXT';
export const TIMELINE_FETCH_PREV         = 'TIMELINE_FETCH_PREV';

// FOOTER
export const FOOTER_STICKY_UPDATE    = 'FOOTER_STICKY_UPDATE';

//USERS ACTIONS
export const USERS_LOGIN_INIT        = 'USERS_LOGIN_INIT';
export const USERS_LOGIN             = 'USERS_LOGIN';
export const USERS_LOGIN_FB          = 'USERS_LOGIN_FB';
export const USERS_LOGIN_TWITTER     = 'USERS_LOGIN_TWITTER';
export const USERS_LOGIN_GOOGLE      = 'USERS_LOGIN_GOOGLE';
export const USERS_LOGOUT            = 'USERS_LOGOUT';
export const USERS_ERROR             = 'USERS_ERROR';

//CATEGORIES
export const CATEGORIES_RECV_DATA     = 'CATEGORIES_RECV_DATA';
export const CATEGORIES_RECV_ERROR    = 'CATEGORIES_RECV_ERROR';

//ACCOUNT
export const ACCOUNT_RECV_SINGLE          = 'ACCOUNT_RECV_SINGLE';
export const ACCOUNT_RECV_COLLECTION      = 'ACCOUNT_RECV_COLLECTION';
export const ACCOUNT_CLEAR_SINGLE         = 'ACCOUNT_CLEAR_SINGLE';
export const ACCOUNT_CLEAR_COLLECTION     = 'ACCOUNT_CLEAR_COLLECTION';


export const ACCOUNT_EDITORIAL_RECV_DATA      = 'ACCOUNT_EDITORIAL_RECV_DATA';
export const ACCOUNT_EDITORIAL_RECV_ERROR     = 'ACCOUNT_EDITORIAL_RECV_ERROR';
export const ACCOUNT_EDITORIAL_SAVE           = 'ACCOUNT_EDITORIAL_SAVE';
export const ACCOUNT_EDITORIAL_SAVE_ERROR     = 'ACCOUNT_EDITORIAL_SAVE_ERROR';
export const ACCOUNT_EDITORIAL_PREVIEW        = 'ACCOUNT_EDITORIAL_PREVIEW';
export const ACCOUNT_EDITORIAL_PUBLISH        = 'ACCOUNT_EDITORIAL_PUBLISH';
export const ACCOUNT_EDITORIAL_PUBLISH_ERROR  = 'ACCOUNT_EDITORIAL_PUBLISH_ERROR';

// COOKIE
export const COOKIES_ACCEPT = 'COOKIES_ACCEPT';



/** WEBPACK FOOTER **
 ** ./frontend/constants/actions.js
 **/